"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Promotion = void 0;

var Promotion =
/** @class */
function () {
  function Promotion() {}

  Promotion.prototype.PromotionType = function () {
    return [{
      slug: 'discount',
      name: 'Discount',
      description: 'Amount Off',
      isDiscount: true,
      isOffer: false,
      isPercentage: false,
      isQuantity: false,
      isShipping: false
    }, {
      slug: 'offer',
      name: 'Offer',
      description: 'Reveal Access Types',
      isDiscount: false,
      isOffer: true,
      isPercentage: false,
      isQuantity: false,
      isShipping: false
    }, {
      slug: 'percentage',
      name: 'Percentage',
      description: '% Off',
      isDiscount: false,
      isOffer: false,
      isPercentage: true,
      isQuantity: false,
      isShipping: false
    }, {
      slug: 'quantity',
      name: 'Quantity',
      description: 'Free Tickets',
      isDiscount: false,
      isOffer: false,
      isPercentage: false,
      isQuantity: true,
      isShipping: false
    }, {
      slug: 'shipping',
      name: 'Shipping',
      description: null,
      isDiscount: false,
      isOffer: false,
      isPercentage: false,
      isQuantity: false,
      isShipping: true
    }];
  };

  return Promotion;
}();

exports.Promotion = Promotion;